const GOOGLE_DOCS_REGEX = /docs\.google\.com\/(document|spreadsheets|presentation|drawings)\/(d|u)\//;

const GOOGLE_SLIDES_REGEX = /docs\.google\.com\/(presentation)\/(d|u)\//;

const DATABOX_REGEX = /\/app.databox.com\/datawall\/.+/;

const isGoogleDocUrl = url => GOOGLE_DOCS_REGEX.test(url);

const isGoogleSlideUrl = url => GOOGLE_SLIDES_REGEX.test(url);

const isDataboxUrl = url => DATABOX_REGEX.test(url);

const shouldEmbedIframe = url => isGoogleDocUrl(url) || isDataboxUrl(url);

export {
    isGoogleDocUrl,
    isDataboxUrl,
    shouldEmbedIframe,
    isGoogleSlideUrl,
};
